import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {useOnboardingStore} from '../store/useOnboardingStore';
import {useGuestGroup, useReservationSettings} from 'hooks';
import {buildGuestOptions, getShouldShowOnlyGuests} from '../utils';
import {isAdult} from 'utils/common';

const useShouldShowOnlyGuests = () => {
  const {guestGroup} = useGuestGroup();
  const {checkCanEditReservationDetails} = useReservationSettings();
  const {participants} = useOnboardingStore();

  return useMemo(
    () =>
      getShouldShowOnlyGuests({
        guestGroup,
        checkCanEditReservationDetails: checkCanEditReservationDetails(),
        totalParticipants: participants.length,
      }),
    [guestGroup, checkCanEditReservationDetails, participants.length],
  );
};

export const useBuildLeaderGuestOptions = () => {
  const {t} = useTranslation();
  const {participants} = useOnboardingStore();
  const shouldShowOnlyGuests = useShouldShowOnlyGuests();

  return useMemo(() => {
    const adults = participants?.filter(guest => isAdult(guest.birth_date)) || [];
    const guestOptions = adults.map(guest => buildGuestOptions(guest));

    if (shouldShowOnlyGuests) {
      return guestOptions;
    }

    return [...guestOptions, {label: t('none_of_the_above'), value: 'none'}];
  }, [participants, shouldShowOnlyGuests, t]);
};
